<template>
  <div class="page-wrapper chiller-theme" id="main">
    <main-sidebar></main-sidebar>
    <main class="page-content">
      <main-header></main-header>
      <c-k-one v-if="$store.getters.selectedTab === 'ckone'"></c-k-one>
      <x-store v-if="$store.getters.selectedTab === 'xstore'"></x-store>
    </main>
  </div>
</template>

<script>
  import MainHeader from './../layout/MainHeader.vue'
  import MainSidebar from './../layout/MainSidebar.vue'
  import XStore from './XStore.vue'
  import CKOne from './CKOne.vue'

  export default {
    name: 'mobileapps',
    components: {
      MainHeader,
      MainSidebar,
      CKOne,
      XStore
    },
    data() {
      return {}
    },
    mounted() {
      this.$store.commit('selectedTab', 'ckone');
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/mobileapps/main/Index.vue